import { AppEnvironment } from 'src/app/shared/models/enums';
import { AppEnvironmentConfig } from './environment.interface';

const domainName = 'dev.rcscbs.com';

export const environment = {
  id: AppEnvironment.Development,
  production: false,
  useMockData: true,
  domainName,
  apiUrl: `https://donation-api.${domainName}/api`,
  companyApiUrl: `https://company-api.${domainName}/api`,
  environmentName: 'dev',
  datadog: {
    applicationId: '',
    clientToken: '',
    site: 'datadoghq.com',
    service: 'donation-web'
  }
} satisfies AppEnvironmentConfig;
